import { c as _c } from "react/compiler-runtime";
import type { Maybe } from '@/types';
import { useState } from 'react';
function getUrl(file: Maybe<File>) {
  if (!file) return null;
  return URL.createObjectURL(file);
}
function useObjectUrl(file) {
  const $ = _c(2);
  let t0;
  if ($[0] !== file) {
    t0 = () => getUrl(file);
    $[0] = file;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [url, setUrl] = useState(t0);
  const [prevFile, setPrevFile] = useState(null);
  if (file !== prevFile) {
    setPrevFile(file);
    if (url) {
      URL.revokeObjectURL(url);
    }
    setUrl(getUrl(file));
  }
  return url;
}
export default useObjectUrl;